import { Api, query } from 'lib/api.mjs';

/** Payouts and the manual revenue override. */

/**
 * Record a payment. The week's breakdown is stamped onto the invoice so a later
 * pay-structure change cannot rewrite what this payment was for.
 *
 * @param {Object} payload
 */
export function recordPayout(payload) {
  return Api.post('/payouts', { body: payload });
}

/** @param {{ id: string }} payload */
export function deletePayout({ id }) {
  return Api.delete(`/payouts/${id}`);
}

/** @param {{ week: string, revenue: number }} payload */
export function saveRevenueOverride({ week, revenue }) {
  return Api.post('/revenue-override', { body: { week, revenue } });
}

/** @param {{ week: string }} payload */
export function clearRevenueOverride({ week }) {
  return Api.delete(`/revenue-override${query({ week })}`);
}
